"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JUMP_TO_CITATION_LABEL = exports.GO_TO_CITATION_LABEL = exports.DOWNLOAD_FAILED_MESSAGE = exports.DOWNLOAD_CITED_FILE_LABEL = exports.CitationModal = exports.CLOSE_CITATION_LABEL = void 0;
exports.citedFileLoadingLabel = citedFileLoadingLabel;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _materialSymbols = require("@design/icons/material-symbols");
var _useFetchApi2 = require("../hooks/useFetchApi");
var _presignedDownload = require("../utils/presignedDownload");
var _documentHeadings = require("../utils/redline/ooxml/document-headings");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var GO_TO_CITATION_LABEL = exports.GO_TO_CITATION_LABEL = "Go to";
var DOWNLOAD_CITED_FILE_LABEL = exports.DOWNLOAD_CITED_FILE_LABEL = "Download";
var JUMP_TO_CITATION_LABEL = exports.JUMP_TO_CITATION_LABEL = "Jump to citation";
var CLOSE_CITATION_LABEL = exports.CLOSE_CITATION_LABEL = "Close cited paragraph";
var DOWNLOAD_FAILED_MESSAGE = exports.DOWNLOAD_FAILED_MESSAGE = "The download failed. Try again.";
var UNNAMED_CITED_FILE = "document";
var HEADING_PATH_SEPARATOR = " › ";
var ABOVE_THE_WHOLE_PANE_LAYER = 10000;
var StoredFilePdfPreview = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./ArtifactCard"));
  }).then(function (artifactCard) {
    return {
      default: artifactCard.StoredFilePdfPreview
    };
  });
});
var styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: ABOVE_THE_WHOLE_PANE_LAYER,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 20px",
    boxSizing: "border-box",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  dialog: {
    position: "relative",
    width: "100%",
    maxWidth: 720,
    padding: 20,
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    padding: 0,
    border: "none",
    background: "none",
    cursor: "pointer",
    color: "#171715"
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    paddingRight: 28
  },
  sectionPath: {
    margin: 0,
    fontSize: 12,
    fontWeight: 600,
    color: "#686766"
  },
  paragraphText: {
    margin: 0,
    fontSize: 13,
    lineHeight: 1.5,
    color: "#171715",
    whiteSpace: "pre-wrap"
  },
  commentBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "6px 8px",
    borderLeft: "3px solid #d9e1ec",
    background: "#f7f8fa"
  },
  commentAuthor: {
    fontSize: 12,
    fontWeight: 600,
    color: "#171715"
  },
  commentText: {
    fontSize: 13,
    lineHeight: 1.5,
    color: "#171715",
    whiteSpace: "pre-wrap"
  },
  previewFrame: {
    position: "relative",
    height: "45vh",
    border: "1px solid #e5e2dd",
    borderRadius: 4,
    overflow: "hidden"
  },
  previewCover: {
    position: "absolute",
    inset: 0
  },
  loading: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    fontSize: 13,
    color: "#686766",
    background: "#f7f8fa"
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    columnGap: 8,
    paddingTop: 20
  },
  failure: {
    marginRight: "auto",
    fontSize: 12,
    color: "#b42318"
  },
  primaryButton: {
    padding: "8px 16px",
    border: "none",
    borderRadius: 8,
    background: "#171715",
    color: "white",
    cursor: "pointer"
  },
  secondaryButton: {
    padding: "8px 16px",
    border: "1px solid black",
    borderRadius: 8,
    background: "white",
    color: "#171715",
    cursor: "pointer"
  },
  unavailableSecondaryButton: {
    padding: "8px 16px",
    border: "1px solid black",
    borderRadius: 8,
    background: "white",
    color: "#171715",
    cursor: "default",
    opacity: 0.4
  }
};
function citedPassageStyle(besidePreview) {
  return {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    maxHeight: besidePreview ? "25vh" : "60vh",
    overflowY: "auto"
  };
}
function citationLocationLabel(headingPath, documentName) {
  var headings = headingPath !== null && headingPath !== void 0 ? headingPath : [];
  var headingsWithinDocument = headings[0] === _documentHeadings.MAIN_PART_NAME ? headings.slice(1) : headings;
  return [].concat(_toConsumableArray(documentName ? [documentName] : []), _toConsumableArray(headingsWithinDocument)).join(HEADING_PATH_SEPARATOR);
}
var CitedComment = function CitedComment(_ref) {
  var comment = _ref.comment;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: styles.commentBlock,
    "data-sentry-component": "CitedComment",
    "data-sentry-source-file": "CitationModal.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: styles.commentAuthor,
      children: comment.author
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: styles.commentText,
      children: comment.text
    })]
  });
};
var CitedFileLoading = function CitedFileLoading(_ref2) {
  var fileName = _ref2.fileName;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "status",
    style: styles.loading,
    "data-sentry-component": "CitedFileLoading",
    "data-sentry-source-file": "CitationModal.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      "data-sentry-element": "svg",
      "data-sentry-source-file": "CitationModal.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "10",
        cy: "10",
        r: "8",
        fill: "none",
        stroke: "#e5e2dd",
        strokeWidth: "2.5",
        "data-sentry-element": "circle",
        "data-sentry-source-file": "CitationModal.tsx"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M10 2 a8 8 0 0 1 8 8",
        fill: "none",
        stroke: "#171715",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        "data-sentry-element": "path",
        "data-sentry-source-file": "CitationModal.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 10 10",
          to: "360 10 10",
          dur: "0.9s",
          repeatCount: "indefinite",
          "data-sentry-element": "animateTransform",
          "data-sentry-source-file": "CitationModal.tsx"
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: citedFileLoadingLabel(fileName)
    })]
  });
};
function citedFileLoadingLabel(fileName) {
  return "Loading ".concat(fileName, "\u2026");
}
var CitedFilePreview = function CitedFilePreview(_ref3) {
  var storageUrl = _ref3.storageUrl,
    fileName = _ref3.fileName,
    citedText = _ref3.citedText,
    onCitedPassageMarked = _ref3.onCitedPassageMarked;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    previewWidthPx = _useState2[0],
    setPreviewWidthPx = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    previewShown = _useState4[0],
    setPreviewShown = _useState4[1];
  var measurePreviewFrame = (0, _react.useCallback)(function (frame) {
    if (frame) setPreviewWidthPx(frame.clientWidth);
  }, []);
  var showPreview = (0, _react.useCallback)(function (jumpToCitedPassage) {
    setPreviewShown(true);
    if (jumpToCitedPassage !== null) onCitedPassageMarked(jumpToCitedPassage);
  }, [onCitedPassageMarked]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: styles.previewFrame,
    ref: measurePreviewFrame,
    "data-sentry-component": "CitedFilePreview",
    "data-sentry-source-file": "CitationModal.tsx",
    children: [previewWidthPx === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StoredFilePdfPreview, {
        storageUrl: storageUrl,
        fileName: fileName,
        widthPx: previewWidthPx,
        citedText: citedText,
        onPreviewShown: showPreview
      })
    }), previewShown ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: styles.previewCover,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CitedFileLoading, {
        fileName: fileName
      })
    })]
  });
};
var CitationModal = exports.CitationModal = function CitationModal(_ref4) {
  var _citation$file_name, _citation$anchor;
  var citation = _ref4.citation,
    host = _ref4.host,
    onClose = _ref4.onClose;
  var _useFetchApi = (0, _useFetchApi2.useFetchApi)(),
    fetchWeb = _useFetchApi.fetchWeb;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    downloadFailed = _useState6[0],
    setDownloadFailed = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    jumpToCitedPassage = _useState8[0],
    setJumpToCitedPassage = _useState8[1];
  var offerJumpToCitedPassage = (0, _react.useCallback)(function (jumpToMarkedPassage) {
    return setJumpToCitedPassage(function () {
      return jumpToMarkedPassage;
    });
  }, []);
  (0, _react.useEffect)(function () {
    var closeOnEscape = function closeOnEscape(event) {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return function () {
      return window.removeEventListener("keydown", closeOnEscape);
    };
  }, [onClose]);
  var citedFileId = citation.file_id;
  var citedFileName = (_citation$file_name = citation.file_name) !== null && _citation$file_name !== void 0 ? _citation$file_name : UNNAMED_CITED_FILE;
  var citedStorageUrl = citation.storage_url;
  var sectionPath = citationLocationLabel((_citation$anchor = citation.anchor) === null || _citation$anchor === void 0 ? void 0 : _citation$anchor.headingPath, citedFileId === null ? host.documentName : citation.file_name);
  var goToCitedParagraph = host.goToCitedParagraph;
  var downloadCitedFile = function downloadCitedFile(storageUrl) {
    setDownloadFailed(false);
    (0, _presignedDownload.downloadStoredObject)(function (path) {
      return fetchWeb(path);
    }, storageUrl, citedFileName).catch(function () {
      return setDownloadFailed(true);
    });
  };
  var citedFilePreview = citedFileId === null || citedStorageUrl === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(CitedFilePreview, {
    storageUrl: citedStorageUrl,
    fileName: citedFileName,
    citedText: citation.text,
    onCitedPassageMarked: offerJumpToCitedPassage
  });
  var footerButtons = citedFileId === null ? goToCitedParagraph === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    style: styles.primaryButton,
    onClick: function onClick() {
      onClose();
      goToCitedParagraph(citation);
    },
    children: GO_TO_CITATION_LABEL
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [downloadFailed ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: styles.failure,
      children: DOWNLOAD_FAILED_MESSAGE
    }) : null, citedStorageUrl === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        style: jumpToCitedPassage === null ? styles.unavailableSecondaryButton : styles.secondaryButton,
        disabled: jumpToCitedPassage === null,
        onClick: function onClick() {
          return jumpToCitedPassage === null || jumpToCitedPassage === void 0 ? void 0 : jumpToCitedPassage();
        },
        children: JUMP_TO_CITATION_LABEL
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        style: styles.secondaryButton,
        onClick: function onClick() {
          return downloadCitedFile(citedStorageUrl);
        },
        children: DOWNLOAD_CITED_FILE_LABEL
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      style: styles.primaryButton,
      onClick: function onClick() {
        onClose();
        host.openCitedFile(citedFileId);
      },
      children: host.openCitedFileLabel
    })]
  });
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: styles.overlay,
    onClick: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      role: "dialog",
      "aria-modal": "true",
      style: styles.dialog,
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        "aria-label": CLOSE_CITATION_LABEL,
        style: styles.closeButton,
        onClick: onClose,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {
          width: 16,
          height: 16
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: styles.body,
        children: [sectionPath ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: styles.sectionPath,
          children: sectionPath
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: citedPassageStyle(citedFilePreview !== null),
          children: [citation.text.trim().length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: styles.paragraphText,
            children: citation.text
          }) : null, citation.comments.map(function (comment, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(CitedComment, {
              comment: comment
            }, index);
          })]
        }), citedFilePreview]
      }), footerButtons === null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: styles.footer,
        children: footerButtons
      })]
    })
  }), document.body);
};